export default {
    tables: state => state.tables,
    reports: state => state.reports,
    cached: state => state.cached,
}